import { GPU_CHART_HEIGHTS } from './constants';

export const getGpuGaugeHeight = (count: number): number => {
  if (count === 1) return GPU_CHART_HEIGHTS.SINGLE;
  if (count === 2) return GPU_CHART_HEIGHTS.DOUBLE;
  if (count === 3) return GPU_CHART_HEIGHTS.TRIPLE;
  return GPU_CHART_HEIGHTS.DEFAULT;
};
